import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-foreground-900 mb-3 font-heading">
          {t("home.conv.title")}
        </h2>
        <p className="text-base md:text-lg text-foreground-500 mb-8 font-body">
          {t("home.conv.subtitle")}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer font-body"
        >
          <span>{t("home.conv.btn")}</span>
          <i className="ri-arrow-right-line" />
        </a>
      </div>
      <div className="mt-10 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Horizontal%20banner%20of%20colorful%20abstract%20geometric%20fashion%20pattern%20with%20overlapping%20circles%20and%20shapes%20in%20warm%20coral%20peach%20sand%20and%20olive%20tones%20artistic%20minimal%20design%20on%20off%20white%20background%20modern%20boutique%20wallpaper%20aesthetic%20soft%20texture&width=1600&height=300&seq=cta-banner-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet fashion products"
          className="w-full h-[200px] object-cover object-top"
          width={1600}
          height={300}
        />
      </div>
    </section>
  );
}